import { LandingFooterComponent } from './Footer/index';
import { LandingContentComponent } from './LandingContent/LandingContent';
import { LandingHeaderComponent } from './header/header';

type Props = {};

export const LandingComponent = (props: Props) => {
  return (
    <div className="landing">
      <LandingHeaderComponent />
      <LandingContentComponent />
      <LandingFooterComponent />
    </div>
  );
};
